class LanguageSelector extends window.BAO.CustomElement() {
  static get requiredElements() {
    return ['toggle', 'options']
  }

  setupListeners() {
    super.setupListeners()

    this.onToggleClick = this.onToggleClick.bind(this)

    this.els.toggle.elements.forEach(toggleEl => {
      this.listeners.add(toggleEl, 'click', this.onToggleClick)
    })

    document.addEventListener('click', this.closeDropdown.bind(this))
  }

  onToggleClick(event) {
    event.stopPropagation()
    this.toggleDropdown()
  }

  toggleDropdown() {
    if (this.classList.contains('is-active')) {
      this.closeDropdown()
    } else {
      this.openDropdown()
    }
  }

  openDropdown() {
    // Force a reflow to ensure the animation starts from the beginning.
    void this.els.options.element.offsetWidth

    this.classList.add('is-active')
    this.els.options.element.setAttribute('aria-hidden', 'false')
  }

  closeDropdown(event) {
    if (event && this.contains(event.target)) return

    this.classList.remove('is-active')

    // Wait for the animation to finish before hiding the dropdown
    setTimeout(() => {
      if (!this.classList.contains('is-active')) {
        this.els.options.element.setAttribute('aria-hidden', 'true')
      }
    }, 200) // This should match the transition duration in CSS
  }
}

customElements.define('language-selector', LanguageSelector)
